"use strict";
const slider = document.querySelector('#compare');
const comparison = document.querySelector('#comparison');
slider.addEventListener('input', () => {
  const value = Number(slider.value);
  comparison.style.setProperty('--split', value + '%');
  slider.setAttribute('aria-valuetext', value + ' percent barefoot, ' + (100-value) + ' percent with Fulton');
});

const reviewTrack = document.querySelector('#review-track');
const reviewPrev = document.querySelector('#reviews-prev');
const reviewNext = document.querySelector('#reviews-next');
function moveReviews(direction) {
 const step = reviewTrack.querySelector('.review-card').getBoundingClientRect().width + parseFloat(getComputedStyle(reviewTrack).gap);
 reviewTrack.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
}
function updateReviewControls() {
 reviewPrev.disabled = reviewTrack.scrollLeft < 2;
 reviewNext.disabled = reviewTrack.scrollLeft >= reviewTrack.scrollWidth - reviewTrack.clientWidth - 2;
}
reviewPrev.addEventListener('click', () => moveReviews(-1));
reviewNext.addEventListener('click', () => moveReviews(1));
reviewTrack.addEventListener('scroll', updateReviewControls);
window.addEventListener('resize', updateReviewControls);
reviewTrack.addEventListener('keydown', event => {
 if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();moveReviews(event.key === 'ArrowRight' ? 1 : -1);}
});
updateReviewControls();

const countdownBar = document.querySelector('#countdown-bar');
let countdownDeadline;
try {
 const savedDeadline = Number(sessionStorage.getItem('fulton-countdown-deadline'));
 countdownDeadline = savedDeadline > 0 ? savedDeadline : Date.now() + 12 * 60 * 60 * 1000;
 sessionStorage.setItem('fulton-countdown-deadline', String(countdownDeadline));
} catch {countdownDeadline = Date.now() + 12 * 60 * 60 * 1000;}
if (Number.isFinite(countdownDeadline) && countdownDeadline > Date.now()) {
 countdownBar.hidden = false;
 function tickCountdown() {
  const seconds = Math.max(0, Math.floor((countdownDeadline - Date.now()) / 1000));
  const values = {hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60};
  Object.entries(values).forEach(([key, value]) => document.querySelector('#countdown-' + key).textContent = String(value).padStart(2, '0'));
  if (seconds === 0) {countdownBar.hidden = true; clearInterval(countdownInterval);}
 }
 const countdownInterval = setInterval(tickCountdown, 1000);
 tickCountdown();
}
